type ActionTypes = {
  FETCH: string
}
const actionTypes: ActionTypes = {
  FETCH: 'FETCH',
} as const;

export default actionTypes;
